import * as ACTIONS from '@/store/constants/actions.js';
import { getConsoleVersion } from '@/resources/cdn.js';

export const actions = {
    [ACTIONS.GET_CONSOLE_VERSION]() {
        return getConsoleVersion();
    },
};
